import { useFetcher } from "@website/fetcher/use-fetcher";
import { useRouter } from "next/router";
import { fetchHotelCalendarData } from "./index.server";
import { HotelDomesticHotelDataType } from "./index.types";

export const useRoomCalendar = (properties: {
  hotelId?: HotelDomesticHotelDataType["id"];
  roomId?: string | number;
}) => {
  const { hotelId, roomId } = properties;
  const router = useRouter();

  const { data, isFetching } = useFetcher({
    enabled: Boolean(hotelId) && Boolean(roomId),
    queryKey: ["roomCalendarData", hotelId, roomId],
    queryFn: ({ queryKey }) =>
      fetchHotelCalendarData(
        queryKey[1] as number,
        queryKey[2] as number,
        router.locale,
        router.query
      )
  });

  return {
    calendar: data,
    isCalendarLoading: isFetching
  };
};
